// extracted by mini-css-extract-plugin
export var motto = "hero-module--motto--kDTKA";
export var sectionHero = "hero-module--sectionHero--Hnccv";
export var slideText = "hero-module--slideText--7JdjK";
export var swiper = "hero-module--swiper--jdBlL";
export var wordsWrapper = "hero-module--wordsWrapper--3pqiY";